import dayjs from 'dayjs'

export const getDepartureTimeBasedOnArrivalTime = ({
  arrivalTime,
  departureTime,
}: {
  arrivalTime?: string
  departureTime?: string
}) => {
  // Avoids empty strings which are not valid ISO strings.
  const _arrivalTime = arrivalTime || undefined
  const _departureTime = departureTime || undefined
  let newDepartureTime = _departureTime

  if (_departureTime) {
    if (_arrivalTime) {
      if (dayjs(_departureTime).isBefore(_arrivalTime)) {
        newDepartureTime = dayjs(_departureTime).add(1, 'day').toISOString()
      } else if (dayjs(_departureTime).day() !== dayjs(_arrivalTime).day()) {
        const _subtractedDay = dayjs(_departureTime).subtract(1, 'day')

        if (_subtractedDay.isAfter(_arrivalTime)) {
          newDepartureTime = _subtractedDay.toISOString()
        }
      }
    }
  } else if (dayjs().day() !== dayjs(_departureTime).day()) {
    newDepartureTime = dayjs(_departureTime)
      .day(dayjs(_arrivalTime).day())
      .toISOString()
  }

  return newDepartureTime
}
